import { useQuery } from 'react-query';
import { getTeamInvites } from '../apis/teams';

export function useTeamInvites() {
   return useQuery(['my-invites'], () => getTeamInvites());
}
